import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContent } from "appworks/components/prompt/prompt-content";
import { FadeIn } from "appworks/graphics/animation/base-animations";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Parallel } from "appworks/utils/contracts/parallel";
import { deviceInfo } from "appworks/utils/device-info";
import { TGRUpdateFreespinsCountsInBetBar } from "commands/tgr-update-freespins-count-in-betbar";
import { DMFNightModeComponent } from "components/dmf-nightmode-component";
import { EpicUIColourComponent } from "epic/components/epic-ui-colour-component";
import { gameLayers } from "game-layers";
import { EnterFreespins } from "slotworks/state-machine/standard/states/enter-freespins";
import { TGRSoundEvent } from "tgr-sound-event-enum";

export class DMFEnterFreespins extends EnterFreespins {

    public onEnter(): void {
        const fsSpine: SpineContainer = gameLayers.Background.getSpine("fs_spine");
        fsSpine.alpha = 0;
        fsSpine.visible = true;
        fsSpine.play("loop");

        uiFlags.set(UIFlag.FREE_SPINS, true);

        TGRUpdateFreespinsCountsInBetBar();

        new Parallel([
            () => FadeIn(fsSpine, 1000),
            () => Components.get(DMFNightModeComponent).nightMode(true, 1000),
            () =>  Components.get(EpicUIColourComponent).adjustFade(80, 2, 1, 1000)
        ]).then(() => super.onEnter());
    }

    protected showPrompt(prompt?: PromptContent, loadStage?: number) {
        prompt = new PromptContent(["freespinswin"], Infinity);
        const record = gameState.getCurrentGame().getCurrentRecord();

        prompt.setText("value", record.getFreespinsWon().toString());
        prompt.setText("click_tap_play", Services.translations.get(`${deviceInfo.isDesktop ? "clk" : "tap" }.ply`));
        prompt.setClickToSkip(true);

        Services.sound.customEvent(TGRSoundEvent.freespinsawarded);

        Components.get(PromptComponent).showPrompt(prompt, loadStage).then(() => this.complete());
    }
}
